export const TITLE = 'CÓ THỂ BẠN CŨNG THÍCH';

export const EMPTY_STATE = {
  TITLE: 'Không tìm thấy sản phẩm nào',
  MESSAGE: 'Chúng tôi sẽ sớm cập nhật sản phẩm mới cho bạn.',
};
